import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import TopBar from "./TopBar";
import CommandPalette from "./CommandPalette";
import AICopilot from "./AICopilot";

export default function AppLayout() {
  const [cmdOpen, setCmdOpen] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === "k") {
        e.preventDefault();
        setCmdOpen((v) => !v);
      }
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, []);

  return (
    <div className="min-h-screen bg-[#09090b] text-white">
      <Sidebar />
      <div className="lg:pl-[248px]">
        <TopBar onOpenCmd={() => setCmdOpen(true)} />
        <main
          data-testid="app-main"
          className="relative px-6 lg:px-10 py-8 lg:py-10 max-w-[1600px] mx-auto"
        >
          <Outlet />
        </main>
      </div>
      <CommandPalette open={cmdOpen} onOpenChange={setCmdOpen} />
      <AICopilot />
    </div>
  );
}
